<template>
<v-btn-toggle v-model="range" color="secondary" mandatory rounded class="mx-3">
  <v-btn text small value="pieReportQuarterHour">{{ $t(`history.range_quarter`) }} </v-btn>
  <v-btn text small value="pieReportHistory"> {{ $t(`history.range_raw`) }} </v-btn>
</v-btn-toggle>
</template>

<script>
export default {
  name: 'HistoryRangeSelector',
  props: {
    value: {
      type: String
    }
  },
  computed: {
    range: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
